import { render, staticRenderFns } from "./ArtistArtworkViewPage.vue?vue&type=template&id=6ff4e691&scoped=true&"
import script from "./ArtistArtworkViewPage.vue?vue&type=script&lang=js&"
export * from "./ArtistArtworkViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ArtistArtworkViewPage.vue?vue&type=style&index=0&id=6ff4e691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4e691",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VFlex,VIcon,VLayout,VProgressCircular,VSlideYTransition,VTooltip})
